import { Button, buttonVariants } from "@/components/ui/button"
import type { VariantProps } from "class-variance-authority"
import { Check, Share2 } from "lucide-react"
import { useState } from "react"

export function ShareButton({ variant = "ghost" }: { variant?: VariantProps<typeof buttonVariants>["variant"] }) {
  const [copied, setCopied] = useState(false)

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(
        `${window.location.href}?utm_source=share_button&utm_medium=cta&utm_campaign=changelog`,
      )
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.log("Share failed:", error)
    }
  }

  return (
    <Button
      variant={variant}
      size="sm"
      onClick={handleShare}
      className={variant === "ghost" ? "text-muted-foreground hover:text-foreground" : ""}
    >
      {copied ? (
        <>
          <Check className="mr-2 h-4 w-4" />
          Copied!
        </>
      ) : (
        <>
          <Share2 className="mr-2 h-4 w-4" />
          Share
        </>
      )}
    </Button>
  )
}
